import { NgModule} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../../../components/shared/shared.module";

// ------------------------------------------Start Service----------------------------------------------------------------------//
import { BsDatepickerModule, BsDropdownModule, CollapseModule, ModalModule } from "ngx-bootstrap";
import { InterceptorService } from "../../../service/components/authentication/interceptor.service";
import { ProFunnelBadgeComponent } from "./profunnel-badge/profunnel-badge.component";
import { Ng2SmartTableModule } from "ng2-smart-table";
import { ProFunnelTableComponent } from "./profunnel-table/profunnel-table.component";
import { PipeModule } from "../../../pipe/pipe.module";
import { ProFunnelProjectComponent } from "./profunnel-project/profunnel-project.component";
import { LoadingModule } from "ngx-loading";
// ------------------------------------------End Service----------------------------------------------------------------------//

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        BrowserModule,
        RouterModule,
        SharedModule,
        BsDropdownModule.forRoot(),
        CollapseModule.forRoot(),
        ModalModule.forRoot(),
        Ng2SmartTableModule,
        PipeModule,
        BsDatepickerModule.forRoot(),
        LoadingModule
    ],
    declarations: [
        ProFunnelBadgeComponent,
        ProFunnelTableComponent,
        ProFunnelProjectComponent
    ],
    exports: [
        ProFunnelBadgeComponent,
        SharedModule,
        Ng2SmartTableModule,
        ProFunnelTableComponent,
        ProFunnelProjectComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true }
    ]
})

export class ProFunnelModule { }
